<template>
  <div class="navigation">
    <h1>MapDrop</h1>
    <div class="links">
      <router-link to="/" exact>Start</router-link>
      <router-link to="/instructions" exact>Anleitung</router-link>
      <router-link to="/about">Über</router-link>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="postcss">
.navigation {
  display: flex;
  justify-content: center;
  align-items: center;

  & h1 {
    margin: 0.8rem 1rem;
    color: var(--main-color);
    text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
  }

  & .links {
    text-align: right;
    font-size: 0.8em;
  }
  & a {
    margin-right: 0.5rem;
    text-decoration: none;
    color: var(--text-color);
    display: inline-block;
    text-align: center;
    padding: 0.5em 1em;
  }
  & .router-link-active {
    outline: 1px solid #aaa;
  }
}
</style>
